export default __webpack_public_path__ + "static/media/russian poker-10.88f7cce6.png";